/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./order-select.vue?vue&type=template&id=4f03710b&scoped=true&"
import script from "./order-select.vue?vue&type=script&lang=ts&"
export * from "./order-select.vue?vue&type=script&lang=ts&"
import style0 from "./order-select.vue?vue&type=style&index=0&id=4f03710b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f03710b",
  null
  
)

export default component.exports